
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forex/sell-forex",
      function () {
        return require("private-next-pages/forex/sell-forex.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forex/sell-forex"])
      });
    }
  